import { connect } from "react-redux";
import CarerDashboard from "../components/CarerApp/CarerDashboard";
import { mapStateToProps, mapDispatchToProps } from "./CarerAppContainer";

export default connect(mapStateToProps, mapDispatchToProps)(CarerDashboard);
